/* ==========================================================
   Creo custom behaviour.

   These three features were last edited as an inline <script> inside
   snippets/theme-scripts.liquid — Yuva's script loader. But
   layout/theme.liquid renders the Palo Alto 'scripts' snippet instead, and
   nothing renders theme-scripts, so none of it ran. Restored here as a
   standalone asset loaded from the layout, rather than rendering the whole
   dead snippet (which would double-load jQuery, Flickity, common.js et al
   on top of what the page already loads).

   Pairs with assets/creo-custom.css, which owns the wipe/spring visuals.
   ========================================================== */

/* Creo custom — subtle mouse-follow on product grid cards.
   Translate + magnet rotation applied to the anchor (.yv-product-img),
   which holds BOTH product photos, so they move as one object.
   Rotation by quadrant: top-left tilts left, top-right tilts right,
   bottom-left tilts right, bottom-right tilts left (rot = -dx*dy). */
(function () {
  var STRENGTH_X = 8; // max px of horizontal drift
  var STRENGTH_Y = 6; // max px of vertical drift
  var MAX_ROT = 3;    // max degrees of magnet tilt (at the corners)
  window.__creoFollowLoaded = true; // debug marker: check in console

  /* The homepage collection panels get the same follow. They carry
     .creo-split-hover and name their anchor .creo-split-media.

     They are deliberately NOT given .yv-product-hover-image: that class is
     also what the touch scroll-walker further down collects, and four panels
     near the top of the homepage would shift its index for every real product
     card below them. */
  var HOVER_TARGET = '.yv-product-hover-image, .creo-split-hover';
  var FOLLOW_ANCHOR = '.yv-product-img, .creo-split-media';

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest(HOVER_TARGET);
      if (!card) return;
      var link = card.querySelector(FOLLOW_ANCHOR);
      if (!link) return;

      var r = card.getBoundingClientRect();
      var dx = ((e.clientX - r.left) / r.width - 0.5) * 2;  // -1 .. 1
      var dy = ((e.clientY - r.top) / r.height - 0.5) * 2;

      /* Horizontal: sqrt curve — steep near center, flattens at edges,
         so small moves around the middle produce the most drift */
      var fx = Math.sign(dx) * Math.sqrt(Math.abs(dx));
      var rot = -dx * dy * MAX_ROT;

      link.style.transform =
        'translate(' + (fx * STRENGTH_X).toFixed(1) + 'px, ' + (dy * STRENGTH_Y).toFixed(1) + 'px) ' +
        'rotate(' + rot.toFixed(2) + 'deg)';
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var card = e.target.closest(HOVER_TARGET);
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return; // still inside

      var link = card.querySelector(FOLLOW_ANCHOR);
      if (link) link.style.transform = '';
    },
    { passive: true }
  );
})();

/* Creo custom — on touch devices (no hover capability), scrolling a
   product card into view triggers the same swap/spring effect that
   mouse users get from :hover, since touch can't hover. */
(function () {
  window.__creoSimpleScrollBoxLoaded = true; // debug marker: check in console

  var isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!isTouchDevice) return;

  function init() {
    var cards = [];
    var activeCard = null;
    var ticking = false;
    var scrolledAccum = 0; // total px scrolled, measured off the first card's own position
    var lastTop = null;
    var STEP_PX = 75; // px of scroll to advance one card, in DOM order (left-to-right, row by row)
    var UNHOVER_DELAY_MS = 250; // how long the previous card lingers active before reverting

    function collectCards() {
      cards = Array.prototype.slice.call(document.querySelectorAll('.yv-product-hover-image'));
    }

    // Cards in the same row sit at (almost) the same vertical center, so
    // picking whichever card is "closest to the viewport center" always
    // ties within a row -- and the leftmost card in DOM order wins every
    // tie, which is why only the left column ever activated. Walking a
    // flat, scroll-distance-driven index through the cards in DOM order
    // instead guarantees every column gets a turn.
    //
    // Distance is measured via the first card's own getBoundingClientRect()
    // rather than window.scrollY: if the page's real scrolling happens on
    // a nested wrapper (common with mobile menus/sticky layouts) instead
    // of window/document, window.scrollY never changes and this whole
    // feature silently never re-fires past the first card. Reading the
    // card's own on-screen position works no matter which element scrolls.
    function updateActiveCard() {
      ticking = false;
      if (!cards.length) return;

      var currentTop = cards[0].getBoundingClientRect().top;
      if (lastTop !== null) {
        scrolledAccum = Math.max(0, scrolledAccum + (lastTop - currentTop));
      }
      lastTop = currentTop;

      var idx = Math.min(cards.length - 1, Math.floor(scrolledAccum / STEP_PX));
      var next = cards[idx];

      if (next && next !== activeCard) {
        if (activeCard) {
          var prev = activeCard;
          setTimeout(function () {
            prev.classList.remove('is-scroll-active');
          }, UNHOVER_DELAY_MS);
        }
        next.classList.add('is-scroll-active');
        activeCard = next;
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateActiveCard);
    }

    collectCards();
    updateActiveCard();

    // capture:true catches scroll events from any scrollable ancestor,
    // not just window -- scroll events don't bubble, so a plain window
    // listener misses scrolling that happens on a nested container.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    var mo = new MutationObserver(function () {
      collectCards();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* Guarded because this used to run from <head> while the body was still
     parsing -- mo.observe(document.body) would throw and kill the feature. */
  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* Creo custom — marks <body> once the shopper scrolls at all, so the
   blinking "scroll down" chevrons next to the Chocolate Collections
   heading (styled in theme-style.liquid) fade out and stay gone. */
(function () {
  function onFirstScroll() {
    document.body.classList.add('creo-has-scrolled');
    window.removeEventListener('scroll', onFirstScroll);
  }
  window.addEventListener('scroll', onFirstScroll, { passive: true });
})();

/* Creo custom — background video loops.

   Mounts any <video data-creo-video data-creo-src="..."> on the page. Used
   for the decorative hero/story loops that replaced YouTube embeds: those
   drew a play/pause overlay on every wrap, which `controls=0` does not
   suppress and no player flag does. A plain <video loop> has no chrome at
   all, wraps at the decoder with no gap, and costs no third-party JS.

   Why the source is withheld until after load: these files are 2-7MB and
   the heroes are the LCP element on their pages. The poster carries first
   paint, then the video mounts and fades in over it.

   Under prefers-reduced-motion nothing is mounted and the poster is the
   whole hero, which is the point of the setting.

   A rejected play() is deliberately swallowed: some mobile browsers and
   Low Power Mode refuse autoplay, and the poster standing in is the
   intended outcome, not a failure worth logging. */
(function () {
  function mount(v) {
    var src = v.getAttribute('data-creo-src');
    if (!src || v.dataset.creoMounted) return;
    v.dataset.creoMounted = '1';

    var s = document.createElement('source');
    s.src = src;
    s.type = v.getAttribute('data-creo-type') || 'video/mp4';
    v.appendChild(s);

    /* Set muted as a property too, not just the attribute: Safari has
       ignored the attribute alone often enough that the autoplay policy
       rejects the play() that follows. */
    v.muted = true;
    v.load();
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  /* KEEP THEM PLAYING WHEN THEY COME BACK ON SCREEN.

     Yuva's common.js binds this to the document:

         document.addEventListener("scroll", () => { ... closeVideoMedia(); ... })

     and closeVideoMedia() pauses every <video> its own isOnScreen() test
     calls off-screen -- on EVERY scroll event, with nothing anywhere that
     ever resumes them. `autoplay` only fires once, so a decorative loop that
     scrolls out of view is paused permanently: scroll back and it is a frozen
     frame. Reproduced on /pages/how-its-made, where a clip paused at 3.08s
     and was still sitting at 3.08s after scrolling back onto it.

     The one escape hatch common.js offers is the class `videoBackgroundFile`,
     which it skips entirely -- but that would leave these playing off-screen
     forever, burning battery on 2-7MB loops. So instead the videos are driven
     properly here: play when on screen, pause when not, which is both the
     correct behaviour and cheaper than what common.js was doing.

     Two parts are needed, because an observer alone loses the race:

     1. The observer sets the intent (`creoWanted`) and acts on it.
     2. A `pause` listener re-asserts play. closeVideoMedia() runs on every
        scroll event, and a video being scrolled TOWARD is already partially
        visible, so it gets paused repeatedly while the visitor approaches --
        undoing the observer's play() again and again. Re-asserting on the
        next frame wins, because our intent outlives any single scroll event.

     `creoWanted` is set to '0' before our own deliberate pause, so this never
     fights the observer when it genuinely wants the video stopped.

     threshold 0 rather than a fraction on purpose: a hero taller than the
     viewport can never reach a ratio like 0.25, and would then never play. */
  function govern(v) {
    v.addEventListener('pause', function () {
      if (v.dataset.creoWanted !== '1' || v.ended) return;
      window.requestAnimationFrame(function () {
        if (v.dataset.creoWanted === '1' && v.paused && !v.ended) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    });
  }

  function observe(vids) {
    if (typeof IntersectionObserver === 'undefined') {
      /* No observer: fall back to keeping them all playing. A stuck frame is
         a worse bug than a loop running off-screen. */
      Array.prototype.forEach.call(vids, function (v) { v.dataset.creoWanted = '1'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.dataset.creoWanted = '1';
          if (v.paused) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        } else {
          v.dataset.creoWanted = '0';
          if (!v.paused) v.pause();
        }
      });
    }, { threshold: 0 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vids = document.querySelectorAll('video[data-creo-video]');
    if (!vids.length) return;
    Array.prototype.forEach.call(vids, function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      govern(v);
      mount(v);
    });
    observe(vids);
  }

  window.creoMountBgVideos = init;

  if (document.readyState === 'complete') {
    setTimeout(init, 200);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 200); });
  }
})();

/* ==========================================================================
   Shared parallax for the Build-a-Bar kraft pattern bands.
   ==========================================================================

   Extracted here on 2026-08-06 when a third band wanted it. It was written
   twice inline first (the Build-a-Bar hero and the homepage reviews
   marquee); a third copy of a rAF loop was not defensible.

   Markup contract:

     <div data-creo-parallax
          data-parallax-rate="0.5"      scroll drift, 0 disables
          data-parallax-hover="26"      pointer drift in px, 0 disables
          data-parallax-counter="-0.34" optional, see below
     >
       <div data-creo-parallax-layer></div>       the tiling pattern
       <div data-creo-parallax-counter>...</div>  optional, moves opposite
     </div>

   The band must be position:relative (or otherwise a containing block) and
   overflow:hidden. The layer must be inset well beyond the band so no drift
   exposes an edge, and must consume the variables in its own transform:

     transform: translate3d(var(--creo-px,0px),
                            calc(var(--creo-sy,0px) + var(--creo-py,0px)), 0);

   Why transform and not background-position: shifting background-position
   repaints the whole band every frame and looked visibly jumpy. A transform
   on a promoted layer is composited with no repaint.

   Why one rAF loop and not work inside the handlers: scroll and mousemove
   fire irregularly and coalesce, so writing style from them stutters. The
   handlers here only record a target; the loop writes once per frame.

   The counter element drifts the OPPOSITE way at a fraction of the
   distance. Two layers moving together just look like the band sliding;
   the opposition is what reads as depth.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function mount(band) {
    var layer = band.querySelector('[data-creo-parallax-layer]');
    if (!layer) return;
    var counter = band.querySelector('[data-creo-parallax-counter]');

    var rate = parseFloat(band.getAttribute('data-parallax-rate'));
    if (!isFinite(rate)) rate = 0.5;
    var hoverMax = parseFloat(band.getAttribute('data-parallax-hover'));
    if (!isFinite(hoverMax)) hoverMax = 26;
    var counterRatio = parseFloat(band.getAttribute('data-parallax-counter'));
    if (!isFinite(counterRatio)) counterRatio = -0.34;

    var targetX = 0, targetY = 0, curX = 0, curY = 0;
    var visible = false, looping = false;

    function frame() {
      if (!visible) { looping = false; return; }

      /* Eased follow, so the pattern trails the cursor rather than
         snapping to it. */
      curX += (targetX - curX) * 0.09;
      curY += (targetY - curY) * 0.09;

      layer.style.setProperty('--creo-sy', (band.getBoundingClientRect().top * -rate).toFixed(2) + 'px');
      layer.style.setProperty('--creo-px', curX.toFixed(2) + 'px');
      layer.style.setProperty('--creo-py', curY.toFixed(2) + 'px');

      if (counter) {
        counter.style.setProperty('--creo-cx', (curX * counterRatio).toFixed(2) + 'px');
        counter.style.setProperty('--creo-cy', (curY * counterRatio).toFixed(2) + 'px');
      }

      window.requestAnimationFrame(frame);
    }
    function start() {
      if (looping) return;
      looping = true;
      window.requestAnimationFrame(frame);
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
      }, { threshold: 0 }).observe(band);
    } else {
      visible = true;
    }

    band.addEventListener('mousemove', function (e) {
      var r = band.getBoundingClientRect();
      targetX = ((e.clientX - r.left) / r.width - 0.5) * 2 * hoverMax;
      targetY = ((e.clientY - r.top) / r.height - 0.5) * 2 * hoverMax;
      start();
    }, { passive: true });

    band.addEventListener('mouseleave', function () {
      targetX = 0;
      targetY = 0;
    }, { passive: true });

    start();
  }

  function init() {
    document.querySelectorAll('[data-creo-parallax]').forEach(function (band) {
      if (band.__creoParallax) return;
      band.__creoParallax = true;
      mount(band);
    });
  }

  window.creoMountParallax = init;

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* Creo custom — add-to-cart feedback.

   The cart chip on the product swells, then flies up to the header cart, which
   pops as it lands. No white flash on the product, and the cart does not open
   by itself.

   The ghost is built from the chip's *computed* style rather than cloned from
   it. A clone would arrive at <body> without the ancestor selectors that give
   it the cream circle -- which is exactly what went wrong first time round: the
   flying element was a bare black outline with no background, and small enough
   to miss.

   Bound on the CAPTURE phase because cart-ajax.js handles the same click on
   bubble and can re-render the button out from under us. Everything here is
   decoration; the add is already handled by the time it runs, and every entry
   point is wrapped so a throw cannot affect the purchase. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SWELL_MS = 170;    /* enlarge in place before anything moves */
  var TRAVEL_MS = 620;   /* then the arc */
  var MIN_SIZE = 46;     /* never smaller than this, or it is hard to follow */
  var LAND_SCALE = 0.78; /* still legible when it arrives */

  function cartIcon() {
    return document.querySelector('.creo-nav-preview-icon--cart')
        || document.querySelector('a[href$="/cart"]');
  }

  /* The chip is hidden until its card is hovered, so at click time it can still
     measure 0x0. Fall back outwards until something has real dimensions. */
  function launchRect(btn) {
    var candidates = [btn, btn.parentElement, btn.closest('.yv-product-options'), btn.closest('.yv-product-card-img')];
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      var r = candidates[i].getBoundingClientRect();
      if (r.width > 4 && r.height > 4) return r;
    }
    return null;
  }

  /* Recreate the chip: its circle, its colours, its icon.

     Two nested elements on purpose. The outer one is moved horizontally and the
     inner one vertically, each with its own easing, which is what produces a
     real arc. Driving both axes from one transform needs a mid-flight waypoint,
     and a waypoint whose time offset does not match its distance offset is
     exactly what made the first version stall in the middle of the screen. */
  function buildGhost(btn, from) {
    var cs = getComputedStyle(btn);
    var size = Math.max(MIN_SIZE, Math.min(from.width, from.height));

    var outer = document.createElement('span');
    outer.className = 'creo-cart-chip-ghost';

    var inner = document.createElement('span');
    inner.className = 'creo-cart-chip-ghost__in';

    var bg = cs.backgroundColor;
    /* A transparent chip would fly as a bare outline. */
    if (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') bg = '#f4eae2';

    outer.style.width = size + 'px';
    outer.style.height = size + 'px';
    outer.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    outer.style.top = (from.top + from.height / 2 - size / 2) + 'px';

    inner.style.background = bg;
    inner.style.color = cs.color || '#2f2a26';
    /* Always a circle in flight, whatever the resting chip's radius is -- the
       card chip is a pill, and a pill scaled down mid-air reads as a smudge. */
    inner.style.borderRadius = '50%';

    var svg = btn.querySelector('svg');
    var icon = cartIcon();
    var headerSvg = icon && icon.querySelector('svg');
    inner.innerHTML = svg ? svg.outerHTML : (headerSvg ? headerSvg.outerHTML : '');

    outer.appendChild(inner);
    return outer;
  }

  function popCart() {
    var icon = cartIcon();
    if (!icon || reduceMotion) return;

    icon.classList.remove('creo-cart-pop');
    void icon.offsetWidth;   /* restart on rapid repeat clicks */
    icon.classList.add('creo-cart-pop');

    /* Fixed, and placed from the icon's own rect, appended to <body>. Appending
       it to the icon's parent centred it on .creo-nav-preview-side--right --
       457px wide -- putting the ring 202px away, out by "Our Story". */
    var r = icon.getBoundingClientRect();
    var ring = document.createElement('span');
    ring.className = 'creo-cart-ring';
    ring.style.left = (r.left + r.width / 2) + 'px';
    ring.style.top = (r.top + r.height / 2) + 'px';
    document.body.appendChild(ring);

    window.setTimeout(function () {
      icon.classList.remove('creo-cart-pop');
      if (ring.parentNode) ring.parentNode.removeChild(ring);
    }, 760);
  }

  function fly(btn) {
    var icon = cartIcon();
    if (!icon) return;
    if (reduceMotion) { popCart(); return; }

    var from = launchRect(btn);
    var to = icon.getBoundingClientRect();
    if (!from || !to.width) { popCart(); return; }

    var ghost = buildGhost(btn, from);
    var inner = ghost.firstChild;
    if (!inner || !inner.innerHTML) { popCart(); return; }
    document.body.appendChild(ghost);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    /* Beat one: swell in place. Short, and it owns the timeline alone so the
       enlargement reads before anything moves. */
    var swell = inner.animate(
      [{ transform: 'scale(0.85)' }, { transform: 'scale(1.3)' }],
      { duration: SWELL_MS, easing: 'cubic-bezier(0.34, 1.7, 0.5, 1)', fill: 'forwards' }
    );

    /* Beat two: the arc. X eases out, Y eases in — the horizontal covers ground
       early while the vertical accelerates late, and the two together curve.
       Both are monotonic, so there is nothing to stall on. */
    var travelX = ghost.animate(
      [{ transform: 'translateX(0px)' }, { transform: 'translateX(' + dx + 'px)' }],
      { duration: TRAVEL_MS, delay: SWELL_MS, easing: 'cubic-bezier(0.25, 0.6, 0.3, 1)', fill: 'forwards' }
    );

    var travelY = inner.animate(
      [
        { transform: 'translateY(0px) scale(1.3)',  offset: 0 },
        { transform: 'translateY(' + (dy * 0.42) + 'px) scale(1.12)', offset: 0.5 },
        { transform: 'translateY(' + dy + 'px) scale(' + LAND_SCALE + ')', offset: 1 }
      ],
      { duration: TRAVEL_MS, delay: SWELL_MS, easing: 'cubic-bezier(0.6, 0, 0.85, 1)', fill: 'forwards' }
    );

    inner.animate(
      [{ opacity: 1, offset: 0 }, { opacity: 1, offset: 0.7 }, { opacity: 0.25, offset: 1 }],
      { duration: TRAVEL_MS, delay: SWELL_MS, easing: 'linear', fill: 'forwards' }
    );

    function land() {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      popCart();
    }

    if (travelY && travelY.finished && travelY.finished.then) {
      travelY.finished.then(land).catch(land);
    } else {
      window.setTimeout(land, SWELL_MS + TRAVEL_MS);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.Sd_addProduct') : null;
    if (!btn || btn.hasAttribute('disabled')) return;
    try { fly(btn); } catch (err) {}
  }, true);
})();

/* Creo custom — collapse the product description's sections into dropdowns.

   Product descriptions are authored in the admin as one long run of copy with
   <h5> headings: Ingredients, Nutrition Facts, Shelf Life (& Storage), Awards.
   Rendered flat that makes a product page a wall of text -- the 12-piece
   assortment ran to ~900px of it.

   This regroups each heading and the blocks under it into a native
   <details>/<summary>, which gets keyboard support, screen-reader semantics and
   find-in-page for free, and keeps every word in the DOM whether or not the
   script runs. Anything before the first heading is the actual product
   description and stays visible.

   Deliberately generic: it splits on whatever headings are present rather than
   matching names, so a product with different sections still works and nothing
   has to be kept in sync with the admin copy. */
(function () {
  var CONTAINERS = '.yv-product-feature-tab-content, .yv-product-description';
  var HEADINGS = 'H1,H2,H3,H4,H5,H6';

  /* Phones collapse the lead copy; everything 768 and up keeps it open. The
     query is read live rather than cached so a rotate lands on the right
     state. */
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;

  function syncLead(details) {
    details.open = !(PHONE && PHONE.matches);
  }

  function buildLead(nodes) {
    var details = document.createElement('details');
    details.className = 'creo-spec creo-spec--lead';

    var summary = document.createElement('summary');
    summary.className = 'creo-spec__summary';
    /* Not translated through the schema because this label is generated, not
       authored -- the other summaries take their text from the admin copy's
       own headings. The theme already ships this string. */
    summary.textContent = (window.creoDescriptionLabel || 'Description');

    var panel = document.createElement('div');
    panel.className = 'creo-spec__body';
    nodes.forEach(function (el) { panel.appendChild(el); });

    details.appendChild(summary);
    details.appendChild(panel);
    syncLead(details);
    return details;
  }

  function syncAllLeads() {
    [].slice.call(document.querySelectorAll('.creo-spec--lead')).forEach(syncLead);
  }

  if (PHONE) {
    /* addListener is the Safari <14 spelling; it is still honoured everywhere
       addEventListener is, so try the modern one first and fall back. */
    if (PHONE.addEventListener) {
      PHONE.addEventListener('change', syncAllLeads);
    } else if (PHONE.addListener) {
      PHONE.addListener(syncAllLeads);
    }
  }

  function enhance(box) {
    if (!box || box.hasAttribute('data-creo-spec-done')) return;

    var kids = [].slice.call(box.children);
    var headingIdx = [];
    kids.forEach(function (el, i) {
      if (HEADINGS.indexOf(el.tagName) !== -1) headingIdx.push(i);
    });
    /* Nothing to group, or the whole thing is one section: leave it alone. */
    if (!headingIdx.length) return;

    box.setAttribute('data-creo-spec-done', '');

    var frag = document.createDocumentFragment();

    /* Everything above the first heading is the description proper. On a phone
       it goes into a dropdown of its own so it costs one row instead of ~180px
       of running copy, which is what lets the buy button clear the fold on a
       bar product page. See the .creo-has-reveal block in creo-custom.css.

       It is wrapped at every width rather than only on phones, so the DOM does
       not change shape on rotate and the MutationObserver below has nothing to
       thrash against. Desktop hides the summary and forces it open (CSS +
       syncLead), so the copy reads there exactly as it always did. */
    var lead = kids.slice(0, headingIdx[0]);
    if (lead.length) {
      frag.appendChild(buildLead(lead));
    }

    headingIdx.forEach(function (start, n) {
      var end = (n + 1 < headingIdx.length) ? headingIdx[n + 1] : kids.length;
      var heading = kids[start];
      var body = kids.slice(start + 1, end);

      /* A heading with nothing under it is not worth a dropdown -- and it is
         not worth a row either. Dark Toasted Coconut's admin copy has a
         "Nutrition Facts" <h5> with no table under it, and emitting the bare
         heading put an empty section on the page (on a phone it also sorted
         above the title, because a loose element has no flex order). Dropping
         it means the section simply appears the moment real copy is added
         under the heading in the admin. */
      if (!body.length) { return; }

      var details = document.createElement('details');
      details.className = 'creo-spec';

      var summary = document.createElement('summary');
      summary.className = 'creo-spec__summary';
      summary.textContent = heading.textContent.trim();

      var panel = document.createElement('div');
      panel.className = 'creo-spec__body';
      body.forEach(function (el) { panel.appendChild(el); });

      details.appendChild(summary);
      details.appendChild(panel);
      frag.appendChild(details);
    });

    box.innerHTML = '';
    box.appendChild(frag);
  }

  function run() {
    [].slice.call(document.querySelectorAll(CONTAINERS)).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The description is re-rendered when a variant changes and when quick view
     injects a product, so pick up containers that appear later. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { run(); });
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        mo.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();
